import React, { Component } from 'react';
import moment from 'moment';

class Sidebar extends Component {
  render() {
    return (
      <div id="sidebar">
        <a href="https://www.linkedin.com/company/10040924/" target="_blank">
          Linkedin
        </a>
        <div className="bottom">Ferreri.co @{moment().year()}</div>
      </div>
    );
  }
}

export default Sidebar;



// WEBPACK FOOTER //
// ./src/components/Sidebar.js